import request from '@/utils/request'

export function pageBanner(query) {
  return request({
    url: '/biz/giftcard/banner/page',
    method: 'get',
    params: query
  })
}

export function saveBanner(data) {
  return request({
    url: '/biz/giftcard/banner/save',
    method: 'post',
    data: data
  })
}

export function deleteBanner(id) {
  return request({
    url: '/biz/giftcard/banner/delete',
    method: 'post',
    params: { id }
  })
}
